<footer>
  <ul class="nav small justify-content-center text-secondary">
    <li class="nav-item">
      &copy;{{ year }} Copyright Boostability Inc. All rights reserved
    </li>
  </ul>
</footer>
